import { Config, system } from 'styled-system';

const config: Config = {
  transform: true,
  transformOrigin: true,
};

export const customTransform = system(config);
